<template>
  <div>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Weekly downloads in the last 13 weeks ({{nowTime}})</span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable"
          active-text="显示数值"
          @change="handleChangelable">
        </el-switch>
        <div id="myCharts" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Monthly downloads in the last 12 months </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable2"
          active-text="显示数值"
          @change="handleChangelable2">
        </el-switch>
        <div id="myCharts2" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> Yearly downloads since {{title3}} </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable3"
          active-text="显示数值"
          @change="handleChangelable3">
        </el-switch>
        <div id="myCharts3" :style="{height: '450px'}"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatDownloadByTime, getSysVal } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      option: {
        title: {
          // text: 'Stacked Line'
          subtext: '',
          left: '5%'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['累计下载数据量', '新增下载数据量']
        },
        grid: {
          left: '4%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            mark: { show: true },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar', 'stack'] },
            magicType: { show: true, type: ['line', 'bar'] },
            // restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLabel: {
            interval: 0,
            rotate: 33
          }
        },
        yAxis: [{
          type: 'value',
          name: 'TB',
          nameTextStyle: {
            color: '#5470c6'
          },
          min: 0,
          alignTicks: true,
          // min: 'dataMin',
          axisLabel: {
            // 使用 formatter 格式化坐标轴的标签
            formatter: function(value) {
                // 返回整数部分即可
                return Math.floor(value);
            }
          }
        },
        {
          type: 'value',
          name: 'TB',
          nameTextStyle: {
            color: '#91cc75'
          },
          position: 'right',
          min: 0,
          alignTicks: true,
          // min: 'dataMin',
          axisLabel: {
            // 使用 formatter 格式化坐标轴的标签
            formatter: function(value) {
                // 返回整数部分即可
                return Math.floor(value);
            }
          }
        }],
        height: '300',
        width: '90%',
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'none'
          },
          {
            type: 'slider',
            yAxisIndex: 1,
            left: '96%',
            fillerColor: '#91cc75',
            borderColor: '#91cc75'
          },
          {
            type: 'slider',
            yAxisIndex: 0,
            left: '0%',
            fillerColor: '#5470c6',
            borderColor: '#5470c6'
          }
        ],
        series: [
          {
            name: '累计下载数据量',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            },
            yAxisIndex: 0
          },
          {
            name: '新增下载数据量',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            },
            yAxisIndex: 1
          }
        ]
      },
      ajax_data: {
        search:{
          stat_type: 'week'
        },
        page:{
          startPage: 1,
          pageLength: 0
        },
        order:{
          item: '',
          type: ''
        }
      },
      title3: '',
      chartsArr1: [],
      chartsArr2: [],
      chartsArr3: [],
      xAxis1: [],
      xAxis2: [],
      xAxis3: [],
      isShowlable: false,
      isShowlable2: false,
      isShowlable3: false,
      ajax_datatime: {},
      nowTime: ''
    }
  },
  mounted() {
    getStatDownloadByTime(this.ajax_data).then(res => {
      this.chartsArr1 = res.result
      let arr1 = []
      for(let i = 13; i >= 1; i--) {
        let xastr = '过去第'+i+'周'
        arr1.push(xastr)
      }
      this.option.xAxis.data = this.xAxis1 = arr1
      let allArr = []
      let newArr = []
      // console.log(resultArr)
      this.chartsArr1.map(item => {
        allArr.push(item.data_size_all)
        newArr.push(item.data_size_new)
      })
      this.option.series[0].data = allArr
      this.option.series[1].data = newArr
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(this.option)
    })
    this.ajax_data.search.stat_type = 'month'
    getStatDownloadByTime(this.ajax_data).then(res => {
      this.chartsArr2 = res.result
      let xastr = []
      let allArr = []
      let newArr = []
      this.chartsArr2.map(item => {
        let substr = item.statmonth.substring(0, 4);
        let newstr = substr+'年'+item.statmonth.substring(4, 6)+'月'
        xastr.push(newstr)
        allArr.push(item.data_size_all)
        newArr.push(item.data_size_new)
      })
      this.option.xAxis.data = this.xAxis2 = xastr
      this.option.series[0].data = allArr
      this.option.series[1].data = newArr
      let charts = this.$echarts.init(document.getElementById('myCharts2'))
      charts.setOption(this.option)
    })
    this.ajax_data.search.stat_type = 'year'
    getStatDownloadByTime(this.ajax_data).then(res => {
      this.chartsArr3 = res.result
      this.title3 = res.result[0].statyear
      let xastr = []
      let allArr = []
      let newArr = []
      this.chartsArr3.map(item => {
        xastr.push(item.statyear+'年')
        allArr.push(item.data_size_all)
        newArr.push(item.data_size_new)
      })
      this.option.xAxis.data = this.xAxis3 = xastr
      this.option.series[0].data = allArr
      this.option.series[1].data = newArr
      let charts = this.$echarts.init(document.getElementById('myCharts3'))
      charts.setOption(this.option)
    })
  },
  created() {
    getSysVal(this.ajax_datatime).then(res => {
      // const parts = res.result[0].sysdate.split(" ")
      // console.log(parts)
      let timestr = res.result[0].sysdate
      this.nowTime = timestr
      // let timearr = timestr.split("-")
      // this.yearstr = timearr[0]
    })
  },
  methods: {
    handleChangelable(val) {
      this.option.xAxis.data = this.xAxis1
      let allArr = []
      let newArr = []
      this.chartsArr1.map(item => {
        allArr.push(item.data_size_all)
        newArr.push(item.data_size_new)
      })
      this.option.series[0].data = allArr
      this.option.series[1].data = newArr

      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(this.option)
    },
    handleChangelable2(val) {
      let xastr = []
      let allArr = []
      let newArr = []
      this.chartsArr2.map(item => {
        let substr = item.statmonth.substring(0, 4);
        let newstr = substr+'年'+item.statmonth.substring(4, 6)+'月'
        xastr.push(newstr)
        allArr.push(item.data_size_all)
        newArr.push(item.data_size_new)
      })
      this.option.xAxis.data = this.xAxis2 = xastr
      this.option.series[0].data = allArr
      this.option.series[1].data = newArr
      
      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts2'))
      charts.setOption(this.option)
    },
    handleChangelable3(val) {
      let xastr = []
      let allArr = []
      let newArr = []
      this.chartsArr3.map(item => {
        xastr.push(item.statyear+'年')
        allArr.push(item.data_size_all)
        newArr.push(item.data_size_new)
      })
      this.option.xAxis.data = this.xAxis3 = xastr
      this.option.series[0].data = allArr
      this.option.series[1].data = newArr

      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts3'))
      charts.setOption(this.option)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
